"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _objectWithoutProperties = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["send"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContractFunctionWithDefaultGasFees = exports.useGasFees = void 0;
var core_1 = require("@usedapp/core");
var ethers_1 = require("ethers");
var react_1 = require("react");
var lodash_1 = require("lodash");
// force gasPrice for fuse/celo
var useGasFees = function useGasFees() {
  var _ref = (0, core_1.useEthers)(),
    chainId = _ref.chainId;
  var gasPrice = (0, react_1.useMemo)(function () {
    //force gas price for celo and ethereum
    switch (chainId) {
      case 122:
        return ethers_1.BigNumber.from(10e9);
      case 42220:
        return ethers_1.BigNumber.from(5e9);
    }
  }, [chainId]);
  return (0, lodash_1.pickBy)({
    gasPrice: gasPrice
  }, function (_) {
    return _ != null;
  });
};
exports.useGasFees = useGasFees;
// wrap usedapp useContractFunction with default gas price for fuse/celo
function useContractFunctionWithDefaultGasFees(contract, functionName, options) {
  var _ref2 = (0, core_1.useContractFunction)(contract, functionName, options),
    send = _ref2.send,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var gasFees = (0, exports.useGasFees)();
  var newSend = (0, react_1.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var numberOfArgs,
      _len,
      args,
      _key,
      hasOpts,
      opts,
      modifiedArgs,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!contract) {
            _context.next = 8;
            break;
          }
          numberOfArgs = contract.interface.getFunction(functionName).inputs.length;
          for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = _args[_key];
          }
          hasOpts = args.length > numberOfArgs;
          opts = hasOpts ? args[args.length - 1] : {};
          modifiedArgs = hasOpts ? args.slice(0, args.length - 1) : args;
          modifiedArgs.push(_objectSpread(_objectSpread({}, gasFees), opts));
          return _context.abrupt("return", send.apply(void 0, _toConsumableArray(modifiedArgs)));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [gasFees, send]);
  return _objectSpread(_objectSpread({}, rest), {}, {
    send: newSend
  });
}
exports.useContractFunctionWithDefaultGasFees = useContractFunctionWithDefaultGasFees;